var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.70712 9.10947C6.22354 6.80192 8.16064 5.75 10 5.75C11.8394 5.75 13.7765 6.80192 15.2929 9.10947C15.6472 9.64859 15.6472 10.3514 15.2929 10.8905C13.7765 13.1981 11.8394 14.25 10 14.25C8.16064 14.25 6.22354 13.1981 4.70712 10.8905C4.35284 10.3514 4.35284 9.64858 4.70712 9.10947ZM16.5465 8.2857C14.8231 5.66314 12.4604 4.25 10 4.25C7.53964 4.25 5.17699 5.66314 3.45357 8.28569C2.77069 9.32484 2.77069 10.6752 3.45356 11.7143C5.17699 14.3369 7.53964 15.75 10 15.75C12.4604 15.75 14.8231 14.3369 16.5465 11.7143C17.2294 10.6752 17.2294 9.32484 16.5465 8.2857ZM9.8973 8.25296C9.93129 8.251 9.96554 8.25 10 8.25C10.9665 8.25 11.75 9.0335 11.75 10C11.75 10.9665 10.9665 11.75 10 11.75C9.03352 11.75 8.25002 10.9665 8.25002 10C8.25002 9.96552 8.25102 9.93127 8.25298 9.89728C8.40532 9.96337 8.57339 10 8.75002 10C9.44038 10 10 9.44036 10 8.75C10 8.57337 9.96339 8.4053 9.8973 8.25296ZM10 6.75C8.2051 6.75 6.75002 8.20507 6.75002 10C6.75002 11.7949 8.2051 13.25 10 13.25C11.7949 13.25 13.25 11.7949 13.25 10C13.25 8.20507 11.7949 6.75 10 6.75Z",
    fill: "#808897"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.0a7fbc136e586a3dcca00bf873dd5c2f.svg";
export { ForwardRef as ReactComponent };